import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="prevent-enter-submit"
export default class extends Controller {
  connect(): void {
    // フォームにキーダウンイベントリスナーを追加
    this.element.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  disconnect(): void {
    // イベントリスナーを削除（メモリリーク防止）
    this.element.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      const target = event.target as HTMLElement;

      // エンターキーを許可する要素かどうかをチェック
      const isAllowedElement =
        target instanceof HTMLTextAreaElement ||  // テキストエリア
        target instanceof HTMLButtonElement ||    // ボタン
        target instanceof HTMLAnchorElement ||    // リンク
        (target instanceof HTMLInputElement && target.type === 'submit'); // submitボタン

      // 許可されていない要素の場合は送信を防止
      if (!isAllowedElement) {
        event.preventDefault();
      }
    }
  }
}
